/**
 * Search params constants
 * @type {string}
 */
export const UPDATE_PARAMS = 'ideal/components/CatalogSearch/UPDATE_PARAMS';
export const REMOVE_PARAM = 'ideal/components/CatalogSearch/REMOVE_PARAM';
export const RESET_PARAMS = 'ideal/components/CatalogSearch/RESET_PARAMS';
export const DOWNLOAD_OFFERS = 'ideal/components/CatalogSearch/DOWNLOAD_OFFERS';

export const FILTERS_RECEIVED =
  'ideal/components/CatalogSearch/FILTERS_RECEIVED';
export const GET_FILTERS = 'ideal/components/CatalogSearch/GET_FILTERS';
